<template>
  <div v-if="from" class="localinfoMap">
    <GmapMap
      :center="{
        lat: center.lat,
        lng: center.lng
      }"
      :zoom="zoom"
      ref="map"
      style="width: 100%; height: 100%">
      <GmapMarker
        :position="{
          lat: from.lat,
          lng: from.lng}"
        :icon="{
          url: iconUrl.hotel,
          scaledSize: iconSize
        }" />
      <GmapMarker
        v-if="location && location !== null"
        :position="{
          lat: location.geometry.location.lat,
          lng: location.geometry.location.lng}"
        :icon="{
          url: iconUrl.place,
          scaledSize: iconSize
        }" />
      <GmapInfoWindow
        v-if="search && search !== null"
        :position="{
          lat: search.lat,
          lng: search.lng}">
        <div class="placeInfo">
          <p class="name mb5">
            <img :src="search.icon" alt="" />
            {{search.name}}
          </p>
          <p class="address mb10">{{search.address}}</p>
          <button type="button" class="btn btnPrimary btnFull" @click="onCreate">{{locale.localinfo_registration}}</button>
        </div>
      </GmapInfoWindow>
    </GmapMap>
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'from',
    'search',
    'location'
  ],
  computed: {
    center () {
      const centerData = this.location ? this.location.geometry.location : this.from
      return centerData
    },
    zoom () {
      return 14
    }
  },
  watch: {
    search: {
      deep: true,
      handler (place) {
        const geo = place === null ? this.from : place
        this.$refs.map.panTo({
          lat: geo.lat,
          lng: geo.lng
        })
      }
    }
  },
  created () {
    this.$store.dispatch('localinfo/getSiteGeo')
  },
  data () {
    return {
      iconUrl: {
        place: require('@/assets/img/location_place.svg'),
        hotel: require('@/assets/img/location_hotel.svg')
      },
      iconSize: {
        width: 45,
        height: 45
      },
      icon: {
        scaledSize: {
          width: 45,
          height: 45
        }
      }
    }
  },
  methods: {
    onCreate () {
      const search = this.search
      if (search && search !== null && window.confirm(`${search.name}:: ${this.locale.confirm_create_localinfo}`)) {
        const placeId = search.placeId
        this.$store.commit('onLoading', true)
        this.$store.dispatch('localinfo/createPlaceid', placeId).then((res) => {
          console.log(res)
          if (res.status === 403) {
            /*
            if (res.message.includes('max places')) {
              console.log('max place')
              alert('지역정보는 최대 400개까지 등록 가능합니다.')
            } else if (res.message.includes('too far')) {
              console.log('too far')
              alert('최대 50km 반경 내의 장소만 등록 가능합니다.')
            } else if (res.message.includes('not supported place type')) {
              console.log('not supported place type')
              alert('지역정보에서 지원하지 않는 타입의 장소입니다.')
            }
            */
            alert(res.message)
          } else {
            alert(this.locale.complete_save)
            this.$emit('preview', res.message)
          }
          this.$store.commit('onLoading', false)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.localinfoMap {
  flex: 1;
  height: 100%;
  padding: 30px;
  border: 1px solid $color-lgrey2;
  background-color: $color-white;
  .gm-style-iw-c {
    overflow: initial !important;
    padding: 0 !important;
    max-height: none !important;
  }
  .gm-style-iw-d {
    overflow: hidden !important;
  }
  .gm-style-iw-d + button {
    display: none !important;
  }
  .gm-style .gm-style-iw-t::after {
    margin-top: -1px;
    background-color: $color-white !important;
  }
  .placeInfo {
    min-width: 200px;
    padding: 15px;
    border-radius: 8px;
    .name {
      position: relative;
      padding-left: 24px;
      font-size: 1.2em;
      font-weight: 700;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 20px;
      }
    }
  }
}
</style>
